import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { Chart } from "react-google-charts";
import DashboardTabs from "../../../../Componants/Common/DashboardTabs";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import { Box, Grid } from "@mui/material";
import Loader from "../../../../Componants/Loader/Loader";
import { Toaster } from "react-hot-toast";
import {
  fetchBrandStats,
  fetchClientStats,
} from "../../../../API Service/apiService";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const Dashboard = () => {
  const [statsList, setStatsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [brandStats, setBrandStats] = useState([]);
  const getStatsList = async () => {
    try {
      setLoading(true);
      const response = await fetchClientStats();
      if (response.status === 200) {
        console.log(response.data);
        setStatsList(response.data.data);
      } else {
        setStatsList([]);
      }
    } catch (error) {
      console.error("Error fetching open call list:", error);
    } finally {
      setLoading(false);
    }
  };

  const getBrandStats = async () => {
    try {
      const response = await fetchBrandStats();
      if (response.status === 200) {
        console.log("Brand Stats Response:", response.data.data);
        setBrandStats(response.data.data);
      } else {
        setBrandStats([]);
        console.log(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching brand stats:", error);
    }
  };
  useEffect(() => {
    getStatsList();
    getBrandStats();
  }, []);

  return (
    <Box component="main">
      {loading && <Loader />}
      <Toaster />

      <div className="firstbox-Dashboard">
        <HeaderNavigation value={" Dashboard"} />
        {/* <div className="firstname-dashboard"></div> */}
        <DashboardTabs />
        <div className="table-dashboard">
          <table class="my-table">
            <tbody>
              <tr>
                <td colspan="2"></td>
                <td colspan="3" className="one">
                  Calls Open Since
                </td>
                <td colspan="2"></td>
                <td colspan="3" className="one">
                  Calls Pending for Part Since
                </td>
              </tr>
              <tr>
                <th>Brand</th>
                <th>Total Calls</th>
                <th>72 Hr</th>
                <th>3-7 Days</th>
                <th>&#62; 7 Days</th>
                <th>Closed</th>
                <th> Pending for Parts</th>
                <th>&#62; 15 Days</th>
                <th>15-30 Days</th>
                <th>&#62; 30 Days</th>
              </tr>
              {statsList.map((item, index) => (
                <tr key={index}>
                  <td>{item.brandName}</td>
                  <td>{item.totalCalls}</td>
                  <td>{item.openCalls.last72Hrs}</td>
                  <td>{item.openCalls.threeTo7Days}</td>
                  <td>{item.openCalls.moreThan7Days}</td>
                  <td>{item.closedCalls}</td>
                  <td>{item.pendingCalls.total}</td>
                  <td>{item.pendingCalls.lessThan15Days}</td>
                  <td>{item.pendingCalls.from15To30Days}</td>
                  <td>{item.pendingCalls.moreThan30Days}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="graph-dashboard">
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            padding: '20px'
          }}>
            {brandStats.map((item, index) => {
              console.log(
                "Monthly Stats for",
                item.brandName,
                ":",
                item.monthlyStats
              );
              return (
                <div key={index} style={{
                  flex: '1 1 calc(50% - 20px)',
                  minWidth: '400px',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  padding: '15px'
                }}>
                  <Chart
                    width={"100%"}
                    height={"350px"}
                    chartType="ColumnChart"
                    loader={<div>Loading Chart</div>}
                    data={[
                      ["Month", "Total Calls", "Closed Calls"],
                      ...item.monthlyStats.map((m) => [
                        monthNames[m.month - 1],
                        parseInt(m.totalCalls),
                        parseInt(m.closedCalls),
                      ]),
                    ]}
                    options={{
                      title: `Total Calls Vs Closed Calls (Month Wise) ${item.brandName}`,
                      isStacked: false,
                      hAxis: {
                        title: "Month",
                        slantedText: true,
                        slantedTextAngle: 45,
                        textStyle: {
                          fontSize: 11
                        }
                      },
                      vAxis: {
                        title: "Number of Calls",
                        minValue: 0,
                        textStyle: {
                          fontSize: 11
                        }
                      },
                      legend: { 
                        position: "top",
                        textStyle: {
                          fontSize: 12
                        }
                      },
                      colors: ["#4285F4", "#34A853"],
                      chartArea: {
                        width: '85%',
                        height: '75%'
                      },
                      fontSize: 12,
                      backgroundColor: { fill:'transparent' }
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Dashboard;
